import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchGetMonitorName, IMonitorName } from 'api/monitor';

export const fetchMonitorData = createAsyncThunk('monitor/fetchMonitorData', async (monitorKey: string) => {
	const response = await fetchGetMonitorName(monitorKey);
	return response;
});

const initialState: IMonitorName = {} as IMonitorName;

const datosBaseMonitorStateSlice = createSlice({
	name: 'datosBaseMonitorState',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(fetchMonitorData.fulfilled, (state, action) => {
			return action.payload;
		});
	}
});

export default datosBaseMonitorStateSlice.reducer;
